export default __webpack_public_path__ + "static/media/lost.38537201.svg";